export default __webpack_public_path__ + "static/media/ai.7e612061.svg";